import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import rootReducer from 'reducers';
import rootSaga from 'sagas';
import { baseApi } from 'services/baseApi';
import Config from 'config';
import { messageMiddleware } from 'middlewares/messageMiddleware';
import { loadingMiddleware } from 'middlewares/loadingMiddleware';

const sagaMiddleware = createSagaMiddleware();
const { env } = Config;

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    thunk: true,
    serializableCheck: false,
    immutableCheck: false,
  })
    .concat(sagaMiddleware)
    .concat(baseApi.middleware).concat(loadingMiddleware)
    .concat(messageMiddleware),
  devTools: env !== 'prd',
});

sagaMiddleware.run(rootSaga);

export type AppStore = typeof store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
